<script lang="ts">
export let field: FieldDisplay & { type: "RichText" };
</script>

<div class="richtext">
	{#if field.contentHTMLComputed}
		{@html field.contentHTMLComputed}
	{/if}
</div>
